import React, { createContext, useContext, useState, useCallback } from 'react';
import config from '../config';

const GeneralContext = createContext();

export const useGeneral = () => useContext(GeneralContext);

export const GeneralProvider = ({ children }) => {
    const [instagramPostId, setInstagramPostId] = useState(null);
    const [stockSource, setStockSource] = useState(2); // 0: Both, 1: Website, 2: Mystand (Defaulting to 2 as requested)
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchInstagramId = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.API_BASE_URL}/api/get_instagram_id/`);
            const data = await response.json();
            if (response.ok && data.instagram_id && data.instagram_id.length > 0) {
                setInstagramPostId(data.instagram_id[0].int_id);
            }
        } catch (err) {
            console.error(err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const updateInstagramId = async (intId) => {
        try {
            const response = await fetch(`${config.API_BASE_URL}/api/update_instagram_id/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ int_id: intId }),
            });
            if (response.ok) {
                setInstagramPostId(intId);
                return { success: true };
            } else {
                const data = await response.json();
                return { success: false, error: data.error };
            }
        } catch (err) {
            return { success: false, error: err.message };
        }
    };

    const fetchStockSource = useCallback(async () => {
        try {
            const response = await fetch(`${config.API_BASE_URL}/api/get_stock_source/`);
            const data = await response.json();
            if (response.ok) {
                setStockSource(data.stock_source);
            }
        } catch (err) {
            console.error(err);
        }
    }, []);

    const updateStockSource = async (source) => {
        try {
            const response = await fetch(`${config.API_BASE_URL}/api/update_stock_source/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({ stock_source: source }),
            });
            if (response.ok) {
                setStockSource(source);
                return { success: true };
            } else {
                const data = await response.json();
                return { success: false, error: data.error };
            }
        } catch (err) {
            return { success: false, error: err.message };
        }
    };

    return (
        <GeneralContext.Provider
            value={{
                instagramPostId,
                stockSource,
                isLoading,
                error,
                fetchInstagramId,
                updateInstagramId,
                fetchStockSource,
                updateStockSource,
            }}
        >
            {children}
        </GeneralContext.Provider>
    );
};
